<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<!-- 选项卡 -->
				<div class="title f-bct">
					<p class="a f-ct"><span class="bor"></span>Тарифы</p>
					<p class="r" @click="back()">Назад</p>
				</div>
				<!-- 列表 -->
				<div class="maitouList f-ct">
					<div class="itm" v-for="(item,index) in imgList">
						<div class="name f-ct">
							<div class="nub">{{index+1}}</div>
							<!-- <p>广东省运输价格表单</p> -->
						</div>
						<div class="imgbox f-bct" @click="showImgViewer">
							<el-image :src="item"></el-image>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 图片预览 -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
	</div>
</template>
<script>
import { quotationList } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	components: {
	  'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
	  'leftBox': () => import('@/components/leftBox.vue')
	},
	data(){
		return {
			imgViewerVisible:false,
			imgList:[require('@/static/tab1.png'),require('@/static/tab2.png'),require('@/static/tab3.png')],
			bannerIdx:0,
			hbSubmitN:false,
			hbDel:false,
			password:'111',
			password1:'',
		}
	},
	mounted() {
		this.quotationList()
	},
	methods:{
		// 查询列表报价单
		async quotationList(){
			const res = await quotationList({})
			if(res.code==200){
				var imgList = []
				res.rows.forEach((item)=>{
					imgList.push(item.image)
				})
				this.imgList = imgList
			}else{this.Tips(res.msg)}
		},
		showImgViewer(){
			this.imgViewerVisible = true;
			const m = (e) => { e.preventDefault() };
		},
		closeImgViewer(){
			this.imgViewerVisible = false;
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.pcon{
	padding: 0 74px;
	padding-bottom: 46px;
}
.banner{
	width: 100%;
	height: 413px;
	.el-image{
		width: 100%;
		height: 413px;
		border-radius: 18px;
	}
	.dian{
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 16px;
		z-index: 2;
		div{
			margin: 0 3px;
			width: 8px;
			height: 8px;
			border-radius: 8px;
			background: #00000033;
			transition:0.3s;
		}
		.a{
			background: #fff;
			width: 14px;
			transition:0.3s;
		}
	}
}
.pageCon{
	margin-top: 32px;
	justify-content: space-between;
	.pageConL{
		width: 530px;
	}
	.pageConR{
		width: calc(100% - 562px);
		.title{
			height: 63px;
			background: #fff;
			border-radius: 12px;
			padding-right: 32px;
			.a{
				.bor{width: 4px;height: 19px;background: #38ABB0;border-radius: 4px;margin-right: 24px;}
				font-size: 18px;
				color: #38ABB0;
			}
			.r{
				font-size: 16px;
				cursor: pointer;
			}
		}
	}
}
.shaixuan{
	// padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	padding-left: 0;
	.l{
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
		}
		.itm1{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			border: 1px solid #DDDDDD;
			border-radius: 4px;
			background: #fff;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
			::v-deep .el-input__inner{
				background: none;
				border: none;
				padding-left: 0;
				width: 240px;
			}
			.el-image{
				display: block;
				width: 16px;
				margin-left: 16px;
				margin-right: 12px;
			}
		}
	}
	.seachBtn{
		// transform: translateX(-12px);
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				// margin-right: 12px;
			}
		}
	}
	.seachBtn1{
		// transform: translateX(-12px);
		div{
			width: 128px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				// margin-right: 12px;
			}
		}
	}
}
.rukuSel{
	.l{
		.el-image{
			width: 20px;
			margin-right: 12px;
		}
		span{
			font-size: 14px;
		}
	}
	.seachBtn{
		p{
			font-size: 14px;
			padding-right: 16px;
		}
		div{
			width: 128px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
		}
	}
}
.maitouList{
	width: 1236px;
	// background: pink;
	transform: translateX(-13px);
	margin-top: 24px;
	.itm{
		width: 386px;
		// height: 136px;
		border-radius: 12px;
		background: #fff;
		padding: 24px;
		// margin-right: 26px;
		margin: 0 13px;
		margin-bottom: 24px;
		.name{
			.nub{
				display: inline-block;
				// width: 30px;
				height: 30px;
				// margin-right: 12px;
				background: #38ABB0;
				color: #fff;
				text-align: center;
				line-height: 30px;
				font-size: 18px;
				padding: 0 10px;
				border-radius: 6px;
			}
			.el-image{
				display: inline-block;width: 45px;
				height: 22px;
				margin-left: 12px;
				margin-right: 8px;
			}
			p{
				display: inline-block;
				font-size: 20px;
				padding-left: 12px;
			}
		}
		.imgbox{
			margin-top: 20px;
			.el-image{
				width: 100%;
				height: 156px;
			}
		}
		
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.title{
		height: 69px;
		padding: 0 30px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 40px;
		.el-image{
			width: 14px;
		}
		p{
			font-size: 18px;
		}
	}
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.txt{
		font-size: 18px;
		font-weight: 600;
		color: #2F3541;
		margin-top: 35px;
		text-align: center;
	}
	.t1{
		font-size: 18px;
		color: #7D7D89;
		// font-weight: 600;
		text-align: center;
		margin-top: 25px;
		span{
			color: #38ABB0;
			padding: 0 4px;
		}
	}
	.t2{
		font-size: 18px;
		color: #FF5F5A;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.t3{
		font-size: 14px;
		color: #999999;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.iptBox{
		width: 403px;
		margin: auto;
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.lab{
			font-size: 16px;
			color: #9A9DA7;
			width: calc(100% - 307px);
		}
		.ipt{
			width: 307px;
			border: 1px solid #E8EDF4;
			border-radius: 8px;
			padding: 0 20px;
			height: 50px;
			display: flex;
			align-items: center;
			::v-deep .el-input__inner{
				border: none;
				padding: 0 0;
				font-size: 0.16rem;
				background: none;
			}
			.selItm{
				display: flex;
				align-items: center;
				margin-right: 80px;
				.el-image{
					width: 20px;
					margin-right: 8px;
				}
				p{
					font-size: 16px;
				}
			}
		}
	}
	.btnBox{
		margin-top: 42px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #F6F6F6;
			color: #666;
		}
		.b2{
			background: #38ABB0;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>